import styled from 'styled-components/macro';
import { Button } from '@yme/atoms/button';
import { colorCoreGray600, colorCoreGray500, colorCoreBlack900Base } from '@yme/tokens/colors';
import { RegularTextLevel3 } from '@yme/tokens/typography';
export const OrderItemStyled = styled.div `
  display: flex;
  box-sizing: border-box;
  padding: 16px;

  &:not(:last-child) {
    border-bottom: 1px solid ${colorCoreGray500};
  }
`;
export const ImageWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  box-sizing: border-box;
  width: 68px;
  height: 68px;

  border: 1px solid ${colorCoreGray600};

  ${({ isRightToLeft }) => (isRightToLeft ? 'margin-left: 12px;' : 'margin-right: 12px;')}
`;
export const OrderItemInfo = styled.div `
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  ${({ isRightToLeft }) => (isRightToLeft ? 'margin-left: 4px;' : 'margin-right: 4px;')}
`;
export const OrderItemName = styled(RegularTextLevel3) `
  margin-bottom: 2px;

  a {
    text-decoration: none;
    color: ${colorCoreBlack900Base};
  }
`;
export const ProductNameStyled = styled.span `
  word-break: break-all;
`;
export const DeleteButton = styled(Button) `
  margin-right: -10px;
`;
